module.exports = __webpack_public_path__ + "media/fonts/BasisGrotesquePro-Black-854d6ac4c2c4e70ffd32b76d71811a8c.woff2";